export class EmployeeTypeCommandResult {
  id: string;
  description: string;

  constructor(values: {
    id: string,
    description: string
  }){
    this.id = values.id;
    this.description = values.description;
  }
}
